import { getGiphySDKRequestHeaders, Logger } from '@giphy/js-util';
import gl from './global';
// TODO remove api key
var environment = (gl === null || gl === void 0 ? void 0 : gl.GIPHY_PINGBACK_URL) || 'https://pingback.giphy.com';
var pingBackUrl = "".concat(environment, "/v2/pingback?apikey=l0HlIwPWyBBUDAUgM");
export var sendPingback = function (events) {
    var headers = getGiphySDKRequestHeaders();
    /* istanbul ignore next */
    headers === null || headers === void 0 ? void 0 : headers.set('Content-Type', 'application/json');
    Logger.debug("Pingback session", events);
    if (!events.length) {
        return new Promise(function (resolve) { return resolve(); });
    }
    return fetch(pingBackUrl, {
        method: 'POST',
        body: JSON.stringify({ events: events }),
        headers: headers,
    }).catch(function (error) {
        // Call failed, probably due to adblock.
        Logger.warn("pingbacks failing to post ".concat(error));
    });
};
//# sourceMappingURL=send-pingback.js.map